{
  "placeholderDescription": "Ikke implementert i sandkassen ennå.",
  "breadcrumb": "Framework · Skogeieroversikt",
  "documentsRowActionsAriaLabel": "Handlinger for dokument"
}
